__turbopack_context__.v({
  "disabled": "TextareaTextField-module-scss-module__DuO0Jq__disabled",
  "error": "TextareaTextField-module-scss-module__DuO0Jq__error",
  "field": "TextareaTextField-module-scss-module__DuO0Jq__field",
  "scroll": "TextareaTextField-module-scss-module__DuO0Jq__scroll",
  "wrapper": "TextareaTextField-module-scss-module__DuO0Jq__wrapper",
});
